var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('Icon',{staticClass:"p-2 cursor-pointer",attrs:{"role":"button","fill":_vm.$scss.primaryText,"hover-fill":_vm.$scss.hoverColor,"name":"dots"},on:{"click":_vm.clickHandler}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }